export enum FederalWithHoldingStatus {
  SingleOrMarriedFillingSeparately = 'SINGLE',
  MarriedFillingJointly = 'MARRIED',
  HeadOfHousehold = 'HEAD',
  None = ''
}
